import { API_V1 } from '../api';
import { parseOrganizationResponse } from '../parse';
import {
	CreateOrganizationRequest,
	FullOrganization,
	FullOrganizationResponse,
	PartialOrganization,
} from './OrganizationModel';

export function getAllOrganizations(): Promise<PartialOrganization[]> {
	return API_V1.get('/organizations')
		.then(({ data }) => data as PartialOrganization[]);
}

export function getAllOrganizationsFull(): Promise<FullOrganization[]> {
	return API_V1.get('/organizations')
		.then(({ data }) => data as FullOrganizationResponse[])
		.then((all) => all.map(parseOrganizationResponse));
}

export function getOrganization(id: number): Promise<FullOrganization> {
	return API_V1.get(`/organization/${id}`)
		.then(({ data }) => data as FullOrganizationResponse)
		.then(parseOrganizationResponse);
}

export function createOrganization(params: CreateOrganizationRequest): Promise<FullOrganization> {
	return API_V1.put('/organization', params)
		.then(({ data }) => data as FullOrganizationResponse)
		.then(parseOrganizationResponse);
}
